import oringinJSONP from 'jsonp'

export default function jsonp (url, data, options) {
  url += (url.indexOf('?') === -1 ? '?' : '') + getParams(data)
  return new Promise((resolve, reject) => {
    oringinJSONP(url, options, (err, data) => {
      if (!err) {
        resolve(data)
      } else {
        reject(err)
      }
    })
  })
}

function getParams (data) {
  let url = ''
  for (let i in data) {
    let value = data[i] === undefined ? '' : data[i]
    url += `&${i}=${encodeURIComponent(value)}`
  }
  return url.substring(1)
}



// WEBPACK FOOTER //
// ./src/api/js/jsonp.js